exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".person-badge-info{margin-bottom:2rem;margin-top:1rem}.person-badge-container{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.person-badge-element{max-width:100px;min-height:104px;padding-left:1rem;padding-right:1rem;padding-bottom:1rem;margin-bottom:1rem;display:flex;justify-content:center;align-items:center;border-bottom:solid #ffffff1a 1px}.person-badge-element>img{width:80px}.person-badge-element>img:hover{cursor:pointer;filter:saturate(2)}.person-badge-element-disabled{filter:grayscale(1);opacity:.2}\n", ""]);

// exports
